module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "tochead"
  }, [_c('b', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chap01"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("  1")]), _vm._v("Says Mark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chap02"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("  2")]), _vm._v("Says Mike")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chap03"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("  3")]), _vm._v("Interview with Craigie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("  4")]), _vm._v("Work for the Errols")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("  5")]), _vm._v("Trouble in Brook Street")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("  6")]), _vm._v("Wally Walks In")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("  7")]), _vm._v("At Midday")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("  8")]), _vm._v("Arrests by the Dozen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("  9")]), _vm._v("Mr Korrel’s Mistake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("10")]), _vm._v("Anson Acts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("11")]), _vm._v("The Errols Agree")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("12")]), _vm._v("Up She Goes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("13")]), _vm._v("Seven Gentlemen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("14")]), _vm._v("Fast Work Fails")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("15")]), _vm._v("Operation B")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("16")]), _vm._v("Panic!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("17")]), _vm._v("Grim Morning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("18")]), _vm._v("Ultimatum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("19")]), _vm._v("Mike and Letty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("20")]), _vm._v("Mark Meets Dora")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("21")]), _vm._v("Down River")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("22")]), _vm._v("Operation C")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("23")]), _vm._v("Across the Seas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("24")]), _vm._v("Shocks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa_toc"
  }, [_vm._v("25")]), _vm._v("… Did Not Take Place")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b833b32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 75
// module chunks = 0